import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { ReactComponent as Close } from '../../assets/images/teamclose.svg';
import { ReactComponent as Team01 } from '../../assets/images/team01.svg';
import TeamInputNumber from './TeamComponents/TeamEditProfile/TeamInput';
import { ListUserIndApi } from '../../store/features/listCoUserIndividual';
import { updateCoUserApi } from '../../store/features/CoUserUpdate';
import { chracterPosition } from '../../utils/index';
import { colorCodesForAvatar } from '../../constants/index';
import { setActiveChatLimit } from '../../Redux/teamSlice';


function ChatLimit({ chatLimitDetail }) {

  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userLogo, setUserLogo] = useState('');
  const [addGroupGeneral, setAddGroupGeneral] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [coUserRoleId, setCoUserRoleId] = useState('');
  const [userUpdate, setUserUpdate] = useState('');
  const [userRole, setUserRole] = useState('');
  const navigate = useNavigate();

  const [getChatLimit, setGetChatLimit] = useState();
  const [chatLimit, setChatLimit] = useState(3);

  const dispatch = useDispatch();

  const handleChatLimitChange = (newLimit) => {
    setChatLimit(newLimit);
    setGetChatLimit(newLimit);
  };

  const getUserlList = async () => {
    const listCoUserList = dispatch(
      ListUserIndApi({
        id: chatLimitDetail.id,
      }),
    );
    listCoUserList
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {

          const item = data?.payload?.data;
          console.log(item);
          setUserName(item.full_name);
          setUserEmail(item.email);
          setUserLogo(item.agent_image);
          setGetChatLimit(item.agent_chat_limit);
          item.groups.forEach((group) => {
            setAddGroupGeneral((prevGroups) => [...prevGroups, group]);
          });
          const updateUserCoRole = item.role_name;
          setSelectedGroups([...selectedGroups]);
          setCoUserRoleId(updateUserCoRole);

          const initialUserUpdate = item.agent_status_id == '1' ? 'Accept Chat'
            : item.agent_status_id == '2' ? 'Don’t Accept chats'
              : item.agent_status_id == '3' ? 'According to working hours' : null;
          setUserUpdate(initialUserUpdate);

          setUserRole(item.role_name);

        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 401) {
          toast.error('Login Expired. Please login  and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          navigate('/login');
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const updateUserHandler = async () => {
    const formData = new FormData();
    formData.append('full_name', userName);
    formData.append('email', userEmail);
    formData.append('agent_chat_limit', chatLimit);

    const updateUser = dispatch(
      updateCoUserApi({
        id: chatLimitDetail.id,
        formData,
      }),
    );
    updateUser
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data.payload.status === 200) {
          toast.success('User Updated successfully.');
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
        dispatch(setActiveChatLimit(false));
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
        dispatch(setActiveChatLimit(false));
      });
  };

  useEffect(() => {
    getUserlList();
  }, []);

  useEffect(() => {
    if (getChatLimit !== '') {
      setChatLimit(getChatLimit);
    }
  }, [getChatLimit]);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  return (
    <>
      <div className="overlay" />
      <div className="Team-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">{t.CHATLIMIT}</p>
          <p className="PopUp-Text02" onClick={() => dispatch(setActiveChatLimit(false))}>
            <Close />
          </p>
        </div> {/* <p className="PopUp-Review-Text">{t.REVIEWTEXT}</p> */}
        <div className="ChatLimit-Container">
          <p>
            {chatLimitDetail.img ? (
              <Avatar
                src={chatLimitDetail.img}
                alt="users logo"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                }}
              />
            ) : (
              <Avatar
                sx={{
                  bgcolor: colorCodesForAvatar[
                    chracterPosition(
                      (chatLimitDetail.name ? chatLimitDetail.name.substring(0, 1) : '').toUpperCase()
                    )
                  ],
                }}
              >
                {(chatLimitDetail.name ? chatLimitDetail.name.substring(0, 1) : '').toUpperCase()}
              </Avatar>

            )}
          </p>
          <div className="ChatLimit-Main">
            <p className="chatKatryn">{chatLimitDetail?.name}</p>
            <p className="chatkenzi">{chatLimitDetail?.email}</p>
          </div>
        </div>
        <div className="Chatselect-Input">
          <TeamInputNumber
            value={chatLimit}
            setGetChatLimit={handleChatLimitChange}
            title="Chat limit"
            placeholder="Select option"
          />
          {/* <p className='input-div'>3 is optimal for rookies</p> */}
        </div>
        <div className="chatLimit-button">
          <button className="SendChat-Button" type="button" onClick={() => setActiveChatLimit(false)}> Cancel</button>
          {' '}
          <button className="SendChat-Button01" type="button" onClick={updateUserHandler}>Apply</button>
        </div>
      </div>
    </>
  );
}

export default ChatLimit;
